<template>
  <div id="user-v2">
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="error">
      <v-container>
        <v-alert type="error" text> This user does not exist. </v-alert>
      </v-container>
    </div>
    <div v-if="user && !error && !loading">
      <v-img
        :src="banner"
        aspect-ratio="16/9"
        id="user-header"
        min-height="200"
        lazy-src="https://i.troplo.com/i/a050d6f271c3.png"
        max-height="150"
      >
      </v-img>
      <v-container>
        <!-- rows and columns with boxes, large title with username, with description, profile links, etc -->
        <v-card-title>
          <v-avatar size="100" class="mr-4">
            <img :src="'https://i.troplo.com/i/' + user.user.avatar" />
          </v-avatar>
          <div>
            <h1 class="headline mb-0">{{ user.user.username }}</h1>
            <div>{{ user.role }}</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-row class="mt-1">
          <v-col>
            <v-card-text class="subtitle-1">
              {{ user.user.description }}
            </v-card-text></v-col
          >
          <v-col md="2">
            <v-card elevation="0" color="toolbar">
              <v-container>
                <v-card-subtitle> Creation date </v-card-subtitle>
                <v-card-title class="mt-n5">
                  {{ $date(user.user.createdAt).format("DD/MM/YYYY") }}
                </v-card-title>
              </v-container>
            </v-card>
            <v-card elevation="0" color="toolbar" class="mt-4">
              <v-container>
                <v-card-subtitle> Mutual collections </v-card-subtitle>
                <v-card-title class="mt-n5">
                  <v-chip-group>
                    <v-chip
                      v-for="collection in user.user.collections"
                      :key="collection.id"
                      :href="`/collection/${collection.id}`"
                      color="primary"
                      text-color="white"
                      small
                    >
                      {{ collection.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-title>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "UserV2",
  data() {
    return {
      error: false,
      loading: true,
      user: null
    }
  },
  computed: {
    banner() {
      return this.user.banner
        ? this.user.banner
        : "https://i.troplo.com/i/a050d6f271c3.png"
    }
  },
  methods: {
    getUser() {
      this.loading = true
      this.axios
        .get("/api/v1/user/" + this.$route.params.user)
        .then((res) => {
          this.user = res.data
          this.loading = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getUser()
  },
  watch: {
    "$route.params.id"() {
      this.error = false
    }
  }
}
</script>

<style scoped></style>
